import { BaseDataService } from './BaseDataService';
import { Tenant } from '../../models';
import { NotificationService } from '../../services';

export class TenantDataService extends BaseDataService<Tenant> {
    constructor(notificationService: NotificationService) {
        super('Tenant', 'Tenants', notificationService);
    }

    calculateMidRanges() {
        const endpoint = `${this.endpointRoot}/midranges`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving teams.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/TenantData.tsx